import { FC } from "react";
import { createPortal } from "react-dom";

import Loading from "./index";
import "./overlay.css";

interface ILoadingOverlayProps {
  show?: boolean;
}

const LoadingOverlay: FC<ILoadingOverlayProps> = ({ show = true }) => {
  if (!show) return null;

  return createPortal(
    <div className="sec-loading-overlay" role="status" aria-live="polite">
      <Loading />
    </div>,
    document.body
  );
};

export default LoadingOverlay;
